import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { useLanguage } from '@/contexts/LanguageContext';
import { useInstructorOrganizations } from '@/hooks/use-instructor-organizations';
import { OrganizationSelector } from '@/components/manager/OrganizationSelector';
import { CourseManagement } from '@/components/instructor/CourseManagement';

export function InstructorDashboard() {
  const { t, dir } = useLanguage();
  const { 
    organizations, 
    selectedOrganization, 
    loading, 
    switchOrganization, 
    hasMultipleOptions,
    contentMode
  } = useInstructorOrganizations();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 md:space-y-8" dir={dir}>
      {/* Header with optional organization selector */}
      <div className={`flex items-center ${hasMultipleOptions ? 'justify-between' : 'justify-start'}`}>
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight">
            {t('dashboard.instructor.dashboard.title')}
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            {selectedOrganization.id === 'general' 
              ? t('dashboard.instructor.dashboard.description')
              : `${t('dashboard.instructor.dashboard.creatingContentFor')} ${selectedOrganization.name}`
            }
          </p>
        </div>

        {/* Organization Selector (if multiple options) */}
        {hasMultipleOptions && (
          <OrganizationSelector
            organizations={organizations}
            selectedOrganization={selectedOrganization}
            onSelect={switchOrganization}
            disabled={loading}
          />
        )}
             </div>

       <CourseManagement 
        contentMode={contentMode} 
        organizationId={selectedOrganization.id !== 'general' ? selectedOrganization.id : undefined}
      />
    </div>
  );
} 